// extracted by mini-css-extract-plugin
var _1 = "ChatroomSkeleton-moduleChatroomSkeleton__C7Fwr Chatroom-moduleChatroom__Z1NjE";
var _2 = "ChatroomSkeleton-modulecontentArea__PBzWV Chatroom-modulecontentArea__ZrkI1";
export { _1 as "ChatroomSkeleton", _2 as "contentArea" }
